import { SUCCESS_RESPONSE_TYPE } from 'api/constants'
import { sendToApi } from 'api/client'
import { makeAutoObservable, observable, ObservableMap } from 'mobx'
import { type RootStore } from 'stores/RootStore'
import { MinimalChannel } from 'types'

type ChannelId = number
type Url = string
type Channel = MinimalChannel

export class ChannelsStore {
  rootStore: RootStore
  channels: ObservableMap<ChannelId, Channel> = observable.map()
  requests: ObservableMap<Url, Promise<Channel>> = observable.map()

  constructor(rootStore: RootStore) {
    this.rootStore = rootStore
    makeAutoObservable(this)
  }

  add = (channel: Channel) => {
    this.channels.set(channel.id, channel)
  }

  bulkAdd = (channels: Channel[]) => {
    channels.forEach(this.add)
  }

  get = (id: ChannelId) => this.channels.get(id)

  fetch = (id: ChannelId) => {
    return new Promise<Channel>((resolve, reject) => {
      const channel = this.channels.get(id)
      if (channel) {
        resolve(channel)
        return
      }
      const url = `/channels/${id}`

      let request = this.requests.get(url)
      if (!request) {
        request = sendToApi<{ channel: Channel }>(url).then((res) => {
          if (res.type !== SUCCESS_RESPONSE_TYPE) {
            throw new Error()
          }
          this.channels.set(id, res.data.channel)
          return res.data.channel
        })
        this.requests.set(url, request)
      }
      request
        .then(resolve)
        .catch(reject)
        .finally(() => this.requests.delete(url))
    })
  }
}
